<template>
    <shop-settlement-info-card title="업체정보" :data="infos" mt="7" />
</template>

<script>
import shopSettlementInfoCard from "../../dumb/shop-settlement-info-card.vue";
export default {
    components: { shopSettlementInfoCard },
    props: {
        store: {
            type: Object,
        },
    },
    computed: {
        companyName() {
            return this.store.meta.companyName || this.store.name;
        },
        phone() {
            return this.store.phone?.phoneNumberFormat() || "없음";
        },
        bankAccount() {
            const { bankname, bankAccount } = this.store;
            return bankname && bankAccount ? `${bankname} / ${bankAccount}` : "없음";
        },
        location() {
            const { postcode, address1, address2 } = this.store;
            if (postcode && address1 && address2) return `[${postcode}] ${address1}, ${address2}`;
            else return "없음";
        },
        infos() {
            return [
                { label: "업체명", value: this.companyName },
                { label: "연락처", value: this.phone },
                // { label: "주소", value: this.location, cols: 12 },
                { label: "계좌", value: this.bankAccount, cols: 12 },
            ];
        },
    },
};
</script>

<style></style>
